import axios from 'axios';
import { baseurl } from '../general';

export default async function post(endpoint, body) {
  const source = axios.CancelToken.source();
  const URL = `${baseurl}${endpoint}/`;
  const res = await axios.post(URL,
    JSON.stringify(body),
    {
      headers: {
        Authorization: `JWT ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
  return [res, source];
}

async function get(endpoint, auth) {
  const source = axios.CancelToken.source();
  const URL = `${baseurl}${endpoint}/`;
  const res = await axios.get(URL,
    {
      cancelToken: source.token,
      headers: auth ? { Authorization: `JWT ${localStorage.getItem('token') || ''}` } : '',
    });
  return [res, source];
}

async function del(endpoint, id) {
  const URL = `${baseurl}${endpoint}/${id}/`;
  const res = await axios.delete(URL,
    { headers: { Authorization: `JWT ${localStorage.getItem('token')}` } });
  return res;
}

async function delBody(endpoint, id, body) {
  const URL = `${baseurl}${endpoint}/${id}/`;
  const res = await axios.delete(URL,
    {
      params: JSON.stringify(body),
      headers: {
        Authorization: `JWT ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
  return res;
}

async function put(endpoint, id, body) {
  const URL = `${baseurl}${endpoint}/${id}/`;
  const res = await axios.put(URL,
    JSON.stringify(body),
    {
      headers: {
        Authorization: `JWT ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',
      },
    });
  return res;
}

export {
  get,
  post,
  del,
  delBody,
  put,
};
